import React from 'react'

export type DividerType = 'solid' | 'dashed' | 'dotted'

export interface DividerProps {
    /** 分隔线类型 */
    type?: DividerType
    /** 分隔线宽度/高度 */
    width?: number | string
    /** 自定义类名 */
    className?: string
}

const Divider: React.FC<DividerProps> = ({
    type = 'solid',
    width = 1,
    className = ''
}) => {
    // 类型样式
    const typeStyles: Record<DividerType, React.CSSProperties> = {
        solid: { borderBottomStyle: 'solid' },
        dashed: { borderBottomStyle: 'dashed' },
        dotted: { borderBottomStyle: 'dotted' }
    }

    const style: React.CSSProperties = {
        ...typeStyles[type],
        borderBottomWidth: typeof width === 'number' ? `${width}px` : width,
        borderColor: '#F2F3F5'
    }

    return <div className={`w-full ${className}`} style={style} />
}

export default Divider
